import { render } from "./BaseSimpleSelect.vue?vue&type=template&id=2c5dc384"
import script from "./BaseSimpleSelect.vue?vue&type=script&lang=js"
export * from "./BaseSimpleSelect.vue?vue&type=script&lang=js"
script.render = render

export default script